<template>
  <b-container fluid class="receipt-container">
<div class="reciep-body styled-reciep">
  <b-img class="bg-logo" src="@/assets/images/logo/logo.png" fluid />

  <h5 class="subtitle">Via do Cliente</h5>

  <div class="reciep-content">
    <b-row v-for="(sell, index) in sellData" :key="index" class="reciep-row">
      <b-col cols="6">
        <span class="reciep-label">{{ sell.title }}:</span>
      </b-col>
      <b-col cols="6">
        <span class="reciep-value">{{ sell.message }}</span>
      </b-col>
    </b-row>

    <b-row v-if="cardBrandData" class="reciep-row">
      <b-col cols="6">
        <span class="reciep-label">Bandeira:</span>
      </b-col>
      <b-col cols="6">
        <b-img
          :src="cardBrandSrc"
          :alt="cardBrandData.text"
          class="card-brand-icon"
        />
      </b-col>
    </b-row>

    <b-row v-if="type === 'transaction'" class="reciep-row">
      <b-col cols="6">
        <span class="reciep-label">Valor da Parcela:</span>
      </b-col>
      <b-col cols="6" class="d-flex align-items-center">
        <span class="reciep-value">{{ parcelPrice }}</span>
        <b-button
          v-b-tooltip.hover.top="'Valor estimado considerando total e parcelas'"
          class="help-button"
        >
          <feather-icon icon="HelpCircleIcon" size="18" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</div>

  </b-container>
</template>

<script>
import {
  BContainer, BRow, BCol, BImg, BButton, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import { reciepTransaction, reciepRecurrence } from '@/service/utilities/reciep'
import { cardBrandIcon } from '@/information/detailsTransaction'

export default {
  components: {
    BButton,
    BContainer,
    BCol,
    BImg,
    BRow,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: ['receiptData', 'type'],

  data() {
    return {
      sellData: null,
    }
  },

  computed: {
    cardBrandData() {
      return cardBrandIcon[this.receiptData?.payment?.card_brand] || null
    },

    cardBrandSrc() {
      return this.cardBrandData
        ? require(`@/assets/images/paymentIcons/${this.cardBrandData.image}`)
        : null
    },

    parcelPrice() {
      const { value, installments_selected } = this.receiptData.payment
      const formatter = new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
      return formatter.format(value / installments_selected)
    },
  },

  mounted() {
    this.sellData = this.doReciep()
  },

  methods: {
    doReciep() {
      if (this.type === 'transaction') return reciepTransaction(this.receiptData)
      if (this.type === 'recurrence') return reciepRecurrence(this.receiptData)
      return []
    },
  },

}

</script>

<style lang="scss" scoped>
  @import "@core/scss/vue/apps/reciep.scss";

  .help-button {
    padding: 0;
    background-color: transparent !important;
    border: none;
  }

  .card-brand-icon {
    max-width: 4.2em;
    max-height: 1.5em;
  }
</style>
